// extracted by mini-css-extract-plugin
export default {"storyDetail":"c-r_hc","storyDetail__photo":"c-r_he"};